/**
 * Customer-facing horizontal lifecycle for a remediation request.
 * Maps API statuses onto ordered milestones in the detail drawer.
 */

export const LIFECYCLE_STEPS = [
  { id: "requested", label: "Requested", statuses: ["REQUESTED"] },
  {
    id: "preview",
    label: "Preview",
    statuses: [
      "ASSUMING_ROLE",
      "CHECKING_PERMS",
      "PRECHECK_RUNNING",
      "PLAN_BUILDING",
      "NEEDS_INPUTS",
      "PRECHECK_FAILED",
      "PERMS_DENIED",
    ],
  },
  { id: "dry_run", label: "Dry-run ready", statuses: ["DRY_RUN_READY"] },
  { id: "approved", label: "Approved", statuses: ["APPROVED"] },
  { id: "running", label: "In progress", statuses: ["IN_PROGRESS"] },
  { id: "complete", label: "Complete", statuses: ["COMPLETED", "ALREADY_REMEDIATED"] },
];

const TERMINAL_CANCELLED = new Set(["CANCELLED", "ABANDONED"]);
const TERMINAL_FAILED = new Set(["FAILED", "VERIFY_FAILED"]);

export function getLifecycleProgress(status) {
  if (!status) {
    return { activeIndex: 0, terminal: null, terminalLabel: null };
  }

  if (TERMINAL_CANCELLED.has(status)) {
    const previewIdx = LIFECYCLE_STEPS.findIndex((s) => s.id === "preview");
    return {
      activeIndex: previewIdx >= 0 ? previewIdx : 0,
      terminal: "cancelled",
      terminalLabel: status === "ABANDONED" ? "Abandoned" : "Cancelled",
    };
  }

  if (TERMINAL_FAILED.has(status)) {
    const runningIdx = LIFECYCLE_STEPS.findIndex((s) => s.id === "running");
    const completeIdx = LIFECYCLE_STEPS.findIndex((s) => s.id === "complete");
    return {
      activeIndex: status === "VERIFY_FAILED" ? completeIdx : runningIdx,
      terminal: "failed",
      terminalLabel: status === "VERIFY_FAILED" ? "Verify failed" : "Failed",
    };
  }

  const activeIndex = LIFECYCLE_STEPS.findIndex((step) => step.statuses.includes(status));
  return {
    activeIndex: activeIndex >= 0 ? activeIndex : 0,
    terminal: null,
    terminalLabel: null,
  };
}
